import Request from '@/common/copyright/request';
import qs from 'qs'

//申请人信息
export const opusUserInfo = () => Request.get(`drama/api/opusUserInfo`);

//草稿增删改查
export const getDramaDraft = (id) => Request.get(`/drama/api/dramaDraft/${id}`,{},{customCode: 'system'});
//export const updateDramaDraft = (data) => Request.put(`/drama/api/dramaDraft`,data,{customCode: 'system'});
export const updateDramaDraft = (data) => Request.put(`/api/opus/dramaOpus/dramaDraft/update`,data,{customCode: 'system'});
//export const addDramaDraft = (data) => Request.post(`/drama/api/dramaDraft`,data,{customCode: 'system'});
export const addDramaDraft = (data) => Request.post(`/api/opus/dramaOpus/dramaDraft/create`,data,{customCode: 'system'});


//类型增删查
export const getDramaCategory = (data) => Request.post('/drama/api/dramaCategory/search/list',data,{customCode: 'system'});
export const addDramaCategory = (data) => Request.post(`/drama/api/dramaCategory/create`,data,{customCode: 'system'});
export const deleteDramaCategory = (id) => Request.delete(`/drama/api/dramaCategory/${id}`);

//阶段增删改查
export const getStage = (id) => Request.get(`/drama/api/dramaDraft/stage/${id}`);
export const updateStage = (data) => Request.put(`/drama/api/dramaDraft/stage`,data,{customCode: 'system'});
export const addStage = (data) => Request.post(`/drama/api/dramaDraft/stage`,data,{customCode: 'system'});
export const deleteStage = (data) => Request.delete(`/drama/api/dramaDraft/stage`,data,{customCode: 'system'});
//像指定阶段前面增加阶段
export const addStageFront = (data) => Request.post(`/drama/api/dramaDraft/stageFront`,data,{customCode: 'system'});



//向阶段中加文件增 删
export const addStageFile = (data, headers) => Request.post(`/drama/api/dramaDraft/file`,data,{customCode: 'system', ...headers});
export const deleteStageFile = (data) => Request.delete(`/drama/api/dramaDraft/file`,data,{customCode: 'system'});



//*********知产迁移************
// 查询文件扣费信息
export const lengthCount = (data) => Request.post(`/drama/api/opus/lengthCount`,data,{customCode: 'system'});
//查询文件存证和脱敏的扣费数目（包含未来存证到期的费用）
export const storeCount = (data) => Request.post(`/drama/api/opus/storeCount`,data,{customCode: 'system'});
// 获取 oss 相关参数 
export const generateStsUploadSignMessage = (data) => Request.post(`/drama/api/opus/generateStsUploadSignMessage`,data,{
    'content-type': "application/json;charset=UTF-8",
    customCode: 'system',
    network400: 'custom400'
});
// 查询原件状态
export const completeStatus = (data) => Request.put(`/drama/api/opus/complete`,data,{
    'content-type': "application/json;charset=UTF-8",
});
// 取消sts上传,返还扣费
export const cancelStsUpload = (data) => Request.post(`/drama/api/opus/cancelStsUpload`,data,{customCode: 'system'});
//批量固化（无源文件)
export const opusApply = (data) => Request.post(`/drama/api/opus/apply/single`,JSON.stringify(data),{
    'content-type': "application/json;charset=UTF-8",
    customCode: 'system'
});

//获取时间戳
export const getCurrentTime = () => Request.get(`/content-plus/api/time/getCurrentTime`);
//获取验证码
export const sendSmsCode = (data) => Request.post(`/content-plus/api/captcha/sendSmsCode`,qs.stringify(data),{
    'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
});
//推送钉钉
export const sendTools = (data) => Request.post(`/content-plus/api/sendTools`,data);
